<div class="captcha-img">
  <canvas #captchaCanvas width="110" height="46" class="rounded"></canvas>
</div>

@if (appearance === 'recovery') {
  <button class="recovery-refresh" type="button" (click)="changeCaptcha($event)" [attr.aria-label]="'new captcha code' | translate">
    <mat-icon aria-hidden="true">refresh</mat-icon>
  </button>
}

<div class="captcha-input p-l-16" [ngClass]="classInput">
  <mat-form-field appearance="outline" class="w-100 p-t-8 tight-input" color="primary" [subscriptSizing]="appearance === 'recovery' ? 'dynamic' : 'fixed'">
    <input
      matInput
      type="text"
      [required]="required"
      [(ngModel)]="captchaEntered"
      (blur)="onInputBlur()"
      (ngModelChange)="onInputChange($event)"
      [maxlength]="captchaLength"
      [placeholder]="appearance === 'recovery' ? ('enter security code' | translate) : placeHolder"
      [attr.aria-label]="appearance === 'recovery' ? ('security code' | translate) : placeHolder"
      autocomplete="off" />

    @if (appearance !== 'recovery') {
      <button type="button" mat-icon-button matSuffix (click)="changeCaptcha($event)" [attr.aria-label]="'new captcha code' | translate">
        <mat-icon>refresh</mat-icon>
      </button>
    }

    @if (appearance !== 'recovery' || captchaMismatch) {
      <mat-hint class="error-msg w-100">
        @if (captchaMismatch) {
          <mat-error class="d-flex align-items-center">
            <mat-icon class="error-icon m-r-6">error_outline</mat-icon><br>
            <span>{{ 'captcha is invalid' | translate }}</span>
          </mat-error>
        }
      </mat-hint>
    }
  </mat-form-field>
</div>
